import IconLogo from './IconLogo';

export default IconLogo;
